module.exports = __webpack_public_path__ + "img/16.2a12eb16.svg";